export enum ESidePanelTabs {
  Layers = 'layers',
  Score = 'score',
  Navigator = 'navigator',
  Information = 'info',
  Tools = 'tools',
  ImageNow = 'image-now',
}

export enum PrintType {
  ExperimentInformation = 'EXPERIMENT_INFORMATION',
  ExperimentBarcode = 'EXPERIMENT_BARCODE',
}

export enum EDefaultSidePanel {
  Information = 'Information',
  Score = 'Score',
  Tools = 'Tools',
  Image = 'Image',
  Navigator = 'Navigator',
}

export const REDIRECT_URL_KEY = 'redirectTo';

export const LICENSE_EXPIRED_KEY = 'licenseExpired';

// Single source of truth for the route paths Layout.tsx matches against and
// navigates to. Route templates used for react-router `matchPath` param
// matching live separately below (SCREEN_PATHS / EXPERIMENT_PATHS).
export const ROUTE_PATHS = {
  ROOT: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  FORGOT: '/forgot',
  FORGOT_PASSWORD: '/forgotPassword',
  INPUT_OTP: '/inputOTP',
  LICENSE_VIOLATE: '/licenseviolate',
  RM_MESSAGE: '/rmmessage',
  REGISTER_COMPUTER: '/registercomputer',
  SESSION_TERMINATION: '/sessiontermination',
  HYBRID_SELECTION: '/hybridselection',
  FEATURE_SELECTION: '/featureselection',
  ACCESS_CONTROL_ERROR: '/accesscontrolerror',
  VERSION_MISMATCH: '/versionmismatch',
  SEAT_LICENSE_VIOLATE: '/seatlicenseviolate',
  PROTEIN: '/protein',
  PROJECT: '/project',
  SEARCH_AND_FILTER: '/snf',
  FRAGMENT: '/fragment',
  EXPERIMENT: '/exp',
  SCREEN: '/screen',
} as const;

// `path.includes()` fragment (no leading slash, intentionally): matches both
// ROUTE_PATHS.LICENSE_VIOLATE and ROUTE_PATHS.SEAT_LICENSE_VIOLATE.
export const LICENSE_VIOLATION_PATH_FRAGMENT = 'licenseviolate';

export const AUTH_FLOW_PATHS = [
  ROUTE_PATHS.LOGIN,
  ROUTE_PATHS.LOGOUT,
  ROUTE_PATHS.INPUT_OTP,
  ROUTE_PATHS.FORGOT_PASSWORD,
  ROUTE_PATHS.LICENSE_VIOLATE,
  ROUTE_PATHS.RM_MESSAGE,
  ROUTE_PATHS.REGISTER_COMPUTER,
  ROUTE_PATHS.SESSION_TERMINATION,
  ROUTE_PATHS.HYBRID_SELECTION,
  ROUTE_PATHS.FEATURE_SELECTION,
  ROUTE_PATHS.ACCESS_CONTROL_ERROR,
  ROUTE_PATHS.VERSION_MISMATCH,
  ROUTE_PATHS.SEAT_LICENSE_VIOLATE,
];

export enum LayoutModalType {
  LicenseUpdate = 'LicenseUpdate',
  DatabaseSizeAlert = 'DatabaseSizeAlert',
}

export const LAYOUT_MODAL_CONFIG: Record<
  LayoutModalType,
  { heading: string; body: string }
> = {
  [LayoutModalType.LicenseUpdate]: {
    heading: 'License Update',
    body: 'You need to update your license to use this feature.',
  },
  [LayoutModalType.DatabaseSizeAlert]: {
    heading: 'Database Size Warning',
    body: 'SQL Server Express database size is reaching its limit.',
  },
};

export const DB_SIZE_ALERT_DISMISSED_KEY = 'dbSizeAlertDismissed';
export const FMLX_SCORE_GROUP = 'Formulatrix Score Group';

export const SCREEN_PATHS = {
  MAIN: '/screen/:id',
  PLATE: '/screen/:id/plate/:plateID',
};

export const EXPERIMENT_PATHS = {
  MAIN: '/exp/:id',
  PLATE: '/exp/:id/plate/:plateID',
};

export const DASHBOARD_PATH = '/';
